import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Hot = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Запеченi сушi'/>
            <main className={s.main}>
                <Product name='Запечений рол з лососем' price='200 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, лосось, огірок, кунжут чорний, сирна шапка'/>
                <Product name='Запечений рол з вугрем' price='250 грн.' weight='310г./8шт.' info1='рис, норі, філаделфія, вугор, огірок, кунжут білий, унарі, сирна шапка'/>
                <Product name='Запечений рол з куркою' price='170 грн.' weight='290г./8шт.' info1='рис, норі, філаделфія, бедро, огірок, кунжут чорний і білий, сир тостовий, унарі'/>
                <Product name='Запечений рол з креветкою' price='210 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, креветка, огірок, кунжут, сирна шапка, унарі'/>
                <Product name='Запечений рол "Фієста"' price='200 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, ківі, лосось, груша, кокосова стружка, соус "Тар-тар", унарі'/>
                <Product name='Запечений рол з беконом' price='180 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, бекон, огірок, панірувальні сухарі, соус сирний'/>
                <Product name='Запечений рол "Спокуса"' price='120 грн.' weight='335г./8шт.' info1='рис, норі, філаделфія, лосось, груша, ківі, кунжут чорний та білий'/>
                
            </main>
        </div>
    )
}

export default Hot;